const WEBVIEW_UA = [
    'WebView',
    '(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)',
    'Android.*(wv|Version/[0-9].[0-9])',
];
const WEB_VIEW_REGEXP = new RegExp(`(${WEBVIEW_UA.join('|')})`, 'ig');
const { userAgent } = window.navigator;

const isWebview = !!userAgent.match(WEB_VIEW_REGEXP);

const isTablet =
    /(ipad|tablet|(android(?!.*mobile))|(windows(?!.*phone)(.*touch))|kindle|playbook|silk|(puffin(?!.*(IP|AP|WP))))/.test(
        userAgent.toLowerCase(),
    );

const isMobile = /(mobi)/.test(userAgent.toLowerCase());

// http://stackoverflow.com/questions/9038625/detect-if-device-is-ios
const isIOS =
    /(ipad|iphone|ipod)/.test(userAgent.toLowerCase()) && !window.MSStream;

const isAndroid = /(android)/.test(userAgent.toLowerCase());

const isIframe = window.top !== window.self;

export { userAgent, isTablet, isMobile, isIOS, isAndroid, isIframe, isWebview };
